export default __webpack_public_path__ + "static/media/logo.b6062df3.png";